import { useAppData } from "../../hooks/useAppData";
import { useFormData } from "../../hooks/useFormData";
import "./clear-storage-btn.css";

export default function ClearStorageBtn({ place }) {
  const { handleNotification } = useAppData();
  const { clearFormData } = useFormData();

  const handleClearStorage = async () => {
    localStorage.removeItem("formdata");
    clearFormData();
    handleNotification("Paikallinen muisti on tyhjennetty");
  };

  return (
    <div
      onClick={handleClearStorage}
      id={place === "landing" ? "clear-storage-btn" : ""}
      className={
        place === "landing" ? "landingpage-button" : "endingpage-button"
      }
    >
      <p>TYHJENNÄ</p>
    </div>
  );
}
